import { DsLibMainMenuRouterLinkArgs } from '../interfaces/ds-lib-main-menu-router-link-args.interface';
import { DsLibMainMenuSectionInterface } from '../interfaces/ds-lib-main-menu-section.interface';
import { DsLibMainMenuLink } from './ds-lib-main-menu-link.model';

/**
 * A menu section contains a list of links. It can be expandable or not.
 */
export class DsLibMainMenuSection {
  /**
   * Optional section title.
   */
  title?: string;

  /**
   * Optional list of links.
   */
  links?: DsLibMainMenuLink[];

  /**
   * Optional : the section can be used as a link
   */
  link?: DsLibMainMenuLink;

  /**
   * The section args an object {key : value} to be replaced in the url
   *
   * @example {sectionId: 675}
   *     key: sectionId
   *     href="/main/projects/582/ged/{sectionId}"
   *     Replaced by the value
   *     href="/main/projects/582/ged/{675}"
   */
  args?: DsLibMainMenuRouterLinkArgs;

  /**
   * Whether the section is expandable and closable
   */
  expandable?: boolean;

  /**
   * Whether the section is expanded
   */
  expanded?: boolean;

  /**
   * Optional icon to display on the left.
   */
  icon?: string;

  /**
   * Optional: the section will only appear if the user has the corresponding right(s).
   */
  rights?: number[];

  /**
   * Optional: the link will use external link if it's true, use routind else
   */
  external?: boolean;

  /**
   * Creates an instance of DsLibMainMenuSection.
   *
   * @param json Given section interface
   */
  constructor(json: DsLibMainMenuSectionInterface) {
    this.title = json.title;
    this.links = json.links ? json.links.map((link) => new DsLibMainMenuLink(link)) : [];
    this.link = json.link ? new DsLibMainMenuLink(json.link) : this.link;
    this.expandable = json.expandable;
    this.args = json.args;
    this.expanded = json.expanded;
    this.icon = json.icon;
    this.rights = json.rights;
    this.external = json.external;
  }
}
